import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Accommodations from "@/components/Accommodations";
import Location from "@/components/Location";
import Gallery from "@/components/Gallery";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function GlampSite() {
  return (
    <div className="font-manrope bg-[#FDFCF8]">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Accommodations />
        <Location />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <GlampSite />
    </LanguageProvider>
  );
}
